import { render, staticRenderFns } from "./EmergencyOrderContainerDetails.vue?vue&type=template&id=7af60a35&scoped=true"
import script from "./EmergencyOrderContainerDetails.vue?vue&type=script&lang=js"
export * from "./EmergencyOrderContainerDetails.vue?vue&type=script&lang=js"
import style0 from "./EmergencyOrderContainerDetails.vue?vue&type=style&index=0&id=7af60a35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af60a35",
  null
  
)

export default component.exports